import { render, staticRenderFns } from "./preview-glasgow.vue?vue&type=template&id=36650ffc&scoped=true"
import script from "./preview-glasgow.vue?vue&type=script&lang=js"
export * from "./preview-glasgow.vue?vue&type=script&lang=js"
import style0 from "./preview-glasgow.vue?vue&type=style&index=0&id=36650ffc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36650ffc",
  null
  
)

export default component.exports